import { render, staticRenderFns } from "./popBox.vue?vue&type=template&id=c6c580e8&"
import script from "./popBox.vue?vue&type=script&lang=js&"
export * from "./popBox.vue?vue&type=script&lang=js&"
import style0 from "./popBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports